import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Users, ArrowLeft } from 'lucide-react';
import ProspectForm from '../../components/prospects/ProspectForm';
import { useGetPromotersQuery } from '../../store/promoterApi';

const AddProspect: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: promoters, isLoading } = useGetPromotersQuery();
  const hasVerifiedPromoter = (promoters ?? []).some((p) => p.isEmailVerified === true);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8 flex items-center justify-center">
        <div className="text-gray-500">{t('common.loading')}</div>
      </div>
    );
  }

  if (!hasVerifiedPromoter) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-sm border border-amber-200 overflow-hidden">
            <div className="border-b border-amber-200 p-6 bg-amber-50">
              <h1 className="text-2xl font-bold text-amber-900">{t('prospects.addUnavailable')}</h1>
              <p className="text-amber-800 mt-1">
                {t('prospects.addUnavailableDesc')}
              </p>
            </div>
            <div className="p-8 flex flex-col items-center text-center">
              <Users className="w-16 h-16 text-amber-500 mb-4" />
              <p className="text-gray-600 mb-6 max-w-md">
                {t('prospects.verificationHelp')}
              </p>
              <button
                type="button"
                onClick={() => navigate('/promoters')}
                className="inline-flex items-center space-x-2 px-6 py-3 bg-[#4339A0] text-white rounded-lg hover:bg-[#3d2f8f] font-medium transition-colors"
              >
                <Users className="w-5 h-5" />
                <span>{t('prospects.goToPromoters')}</span>
              </button>
              <button
                type="button"
                onClick={() => navigate('/prospects')}
                className="inline-flex items-center space-x-2 mt-4 text-gray-600 hover:text-gray-900"
              >
                <ArrowLeft className="w-4 h-4" />
                <span>{t('prospects.backToProspects')}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm">
          <div className="border-b border-gray-200 p-6 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-t-xl">
            <h1 className="text-2xl font-bold">{t('prospects.addNew')}</h1>
            <p className="text-green-100 mt-1">{t('prospects.addFormSubtitle')}</p>
          </div>

          <div className="p-8">
            <ProspectForm onClose={() => navigate('/prospects')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProspect;
